import type { TrackFunction } from "@similarweb/contact-us";

import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

export default function createActivationAgentTrackingService(track: TrackFunction) {
    function trackEvent(action: string, eventName: string, eventSubName?: string, eventSubSubName?: string): void {
        const event: string = createTrackingEventName(eventName, eventSubName, eventSubSubName);

        track("setup agent", action, event);
    }

    function trackClickEvent(eventName: string, eventSubName?: string, eventSubSubName?: string): void {
        trackEvent("click", eventName, eventSubName, eventSubSubName);
    }

    return {
        trackRoleChange(selectedRole: string, userInput?: string): void {
            trackEvent("edit", "change user role", selectedRole, userInput);
        },
        trackSelectPersona(selectedPersona: string): void {
            trackClickEvent("select persona", selectedPersona);
        },
        trackAddPersona(personaName: string): void {
            trackClickEvent("add persona", personaName);
        },
        trackSelectType(type: string): void {
            trackClickEvent("select type", type);
        },
        trackAddCompanyType(type: string): void {
            trackClickEvent("add type", type);
        },
        trackSelectSignal(signal: string): void {
            trackClickEvent("select signal", signal);
        },
        trackSubmit(selectedRole: string, types: readonly string[]): void {
            trackClickEvent("finish setup", selectedRole, types.join(","));
        },
        trackClose(selectedRole: string, types: readonly string[]): void {
            trackClickEvent("leave setup", selectedRole, types.join(","));
        },
    };
}
